import styled from '@emotion/styled'
import { Flex, Icon, Text } from '@collable/ui'
import { type Menu } from './type'
import { Link } from 'react-router'
import pagePath from '@/utils/pagePath'
import { useGetChannelOwnerships } from '@/api/channel'
import { useMemo } from 'react'

interface MenuNavProps {
  selectedMenu?: Menu
}

const MenuNav = ({ selectedMenu }: MenuNavProps) => {
  const { data: channelOwnerships } = useGetChannelOwnerships()

  const menus: Array<{
    title: string
    href: string
    menu: Menu
    iconName: 'customMenu' | 'customPlay'
  }> = useMemo(
    () => [
      {
        title: '내 영상 관리',
        href: pagePath.channelVideos(channelOwnerships?.[0]?.email ?? ''),
        menu: 'videos',
        iconName: 'customMenu',
      },
      {
        title: '내 채널 정보',
        href: pagePath.channelDetail(channelOwnerships?.[0]?.email ?? ''),
        menu: 'channels',
        iconName: 'customPlay',
      },
    ],
    [channelOwnerships],
  )
  return (
    <Container as="nav" gap={4} justifyContent="center">
      {menus.map(menu => {
        const isSelected = menu.menu === selectedMenu
        return (
          <Menu to={menu.href} key={menu.menu} isSelected={isSelected}>
            <Icon
              name={menu.iconName}
              iconSize={16}
              iconColor={isSelected ? 'primaryNormal' : 'labelDisable'}
            />
            <Text
              size="body3"
              fontWeight={isSelected ? 'bold' : 'medium'}
              color={isSelected ? 'labelStrong' : 'labelAssistive'}
            >
              {menu.title}
            </Text>
          </Menu>
        )
      })}
    </Container>
  )
}

export default MenuNav

const Container = styled(Flex)`
  background-color: ${({ theme }) => theme.common.commonWhite};
  flex: 1;
`

const Menu = styled(Link)<{
  isSelected: boolean
}>`
  display: flex;
  height: 40px;
  align-items: center;
  gap: 8px;
  border-radius: 10px;
  padding: 4px 16px;

  background-color: ${({ theme, isSelected }) =>
    isSelected ? theme.fill.fillAssistive : 'transparent'};
`
